import { render, staticRenderFns } from "./MangheMadeGoodsOrder.vue?vue&type=template&id=04a17a02&scoped=true&"
import script from "./MangheMadeGoodsOrder.vue?vue&type=script&lang=js&"
export * from "./MangheMadeGoodsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a17a02",
  null
  
)

export default component.exports